import type {BuilderMergeTags} from 'crqlar-react-common/dist/components/ContentEditor.component';

import type {AvailableVariable} from './nodeVariables';
import {automationVariableToken} from './variableReferences';

/** A fixed group after the steps, e.g. the property's own fields; each `key` inserts `{{key}}`. */
export interface BuilderMergeTagGroup {
    name: string;
    fields: {label: string; key: string}[];
}

/** The builder's variable menu: one submenu per earlier step, in the order given, each field inserting its reference. */
export const builderMergeTags = (variables: AvailableVariable[], hotel?: BuilderMergeTagGroup): BuilderMergeTags => {
    const steps: BuilderMergeTags = {};
    const keyOf = new Map<string, string>();

    variables.forEach(variable => {
        const nodeName = variable.nodeName ?? '';
        if (!keyOf.has(nodeName)) {
            // Positional keys: a label may hold any character, and Unlayer only needs them unique.
            keyOf.set(nodeName, `step${keyOf.size}`);
            steps[keyOf.get(nodeName)!] = {name: nodeName, mergeTags: {}};
        }
        const fields = steps[keyOf.get(nodeName)!].mergeTags!;
        fields[`field${Object.keys(fields).length}`] = {
            name: variable.name,
            value: automationVariableToken({nodeName, name: variable.name})
        };
    });

    if (hotel) {
        // Fixed key: never collides with the positional `step<n>` keys.
        steps.hotel = {
            name: hotel.name,
            mergeTags: Object.fromEntries(hotel.fields.map((field, index) => [
                `field${index}`, {name: field.label, value: `{{${field.key}}}`}
            ]))
        };
    }

    return steps;
};
